module.exports = __webpack_public_path__ + "static/media/educational-resource.4054e02a.svg";